import { Nullable } from "~/types/general.types";

export const formTitleForId = (title?: Nullable<string>) =>
  (title || "").trim().replaceAll(" ", "-").toLowerCase();
